/* eslint-disable vue/no-v-html */
<template>
  <svg
    :viewBox="viewBox"
    preserveAspectRatio="xMidYMid meet"
    focusable="false"
    style="pointer-events: none; display: block;"
    class="icon"
    :size="size"
  >
    <g :id="iconName" v-bind="gAttributes" v-html="innerSvg" />
  </svg>
</template>

<script>
import iconset from "./iconset.js";

export default {
  name: "NsIcon",
  props: {
    /**
     * iconName selects the name of the icon which is also a key from an object imported by NsIcon.
     * This is passed to NsIcon by doing something like <ns-icon icon-name="icon-smallcart-empty" />
     */
    iconName: {
      type: String,
      required: true,
      default: ""
    },
    /**
     * size is a data attribute that accepts the following: icon-micro, icon-sm, icon-lg
     */
    size: {
      type: String,
      required: false,
      default: "icon-sm"
    }
  },
  data() {
    return {
      /**
       * icons is the iconset object imported from icons.js. Each key in the icons object
       * represents a different icon
       */
      icons: iconset
    };
  },
  computed: {
    /**
     * gAttributes is unique to each SVG icon. These attributes are applied the base <g></g> tag in
     * the <svg></svg> tag. An example of this looks something like this:
     * fill="none" stroke-width="1" stroke="currentColor" transform="translate(-53.000000, -15.000000)"
     */
    gAttributes() {
      let attrs = [];
      if (this.iconName.length > 0) {
        this.icons[this.iconName].g.forEach(attr => {
          let key = Object.keys(attr)[0];
          attrs.push({ [`${key}`]: attr[key] });
        });
      }

      return attrs;
    },
    /**
     * innerSvg is the SVG code inside the main <g></g> tag within the SVG.
     */
    innerSvg() {
      let parts = "";
      if (this.iconName.length > 0) {
        this.icons[this.iconName].parts.forEach(part => {
          parts += part;
        });
      }

      return parts;
    },
    viewBox() {
      let viewBox = "";
      if (this.iconName.length > 0) {
        viewBox = this.icons[this.iconName].viewBox;
      }

      return viewBox;
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
[size="icon-micro"] {
  height: 16px;
  width: 16px;
}
[size="icon-sm"] {
  height: 20px;
  width: 20px;
}
[size="icon-md"] {
  height: 24px;
  width: 24px;
}
[size="icon-lg"] {
  height: 30px;
  width: 30px;
}
svg {
  fill: currentColor;
  stroke: none;
}
</style>
